import {LoDashStatic} from "lodash";
import IScope = angular.IScope;
require('./articlesProfileTable.less');
const _ = <LoDashStatic> require('lodash');

class TableController {
    tableDefinition;
    selected = [];
    universalDate;

    query ={
        limit: 100,
        page: 1,
        order: ''
    };
    filter = {
        filterText: "",
        active: false
    };
    articles;
    constructor(private $state, private toastService, private OrderLines, private $filter, private ArticleDemands){}
    
    confirmDate(line, index){
        var parsedDate = this.$filter('date')(line.confirmedDate, 'yyyy-MM-dd');
        this.OrderLines.setConfirmationDate({lineId:line.uniqueId, confirmationDate:parsedDate}, {}).$promise.then(
            ()=>{
                line.altered = false;
                this.toastService.showSimpleToast("Bekreftet dato har blitt satt!", 3000);
            },

            (error)=>{
                this.toastService.parseError(error)
            }
        );
    }

    confirmEveryAlteredDate(){
        if(this.selected.length){
            _.forEach(this.selected,(line, index:number)=>{
                line.confirmedDate = this.universalDate;
                this.confirmDate(line, index)
            });
        }
        this.selected = [];
    }
    
    setAltered(line){
        line.altered = true;
    }
    
    goToDetails(ev, line) {
        if(line.orderType !== 'PURCHASE_ORDER') {
            ev.stopPropagation();
            this.$state.go('loggedin.orders_orderdetails', {orderNo: line.orderNo});
        }
    }

    stopProp(ev) {
        ev.stopPropagation();
    }

    goBack() {
        window.history.back();
    }

    setFilterState(s) {
        this.filter.filterText = "";
        this.filter.active = s;
    }

    calculateAnalyzedTime() {
        this.ArticleDemands.trigger({}, {articleNos: [this.articles.articleNo]}).$promise.then(
            ()=>{
                this.toastService.showSimpleToast("Tilgjengelighetsanalyse startet", 5000);
            },

            (error)=>{
                this.toastService.parseError(error)
            }
        );
    }
   
}

class ArticlesProfileTableOptions implements ng.IComponentOptions {
    bindings: any = {
        articles:'=',
        tableDefinition:'='
    };
    controller: string = 'rkcArticlesProfileTableController';
    controllerAs:string = 'c';
    template: any = require('./articlesProfileTable.html');
}

rkcApp.controller("rkcArticlesProfileTableController", [ '$state', 'toastService','OrderLines','$filter', 'ArticleDemands', function( $state, toastService,OrderLines, $filter, ArticleDemands){
    return new TableController($state, toastService,OrderLines, $filter, ArticleDemands);
}])
    .component("rkcArticlesProfileTable", new ArticlesProfileTableOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/articleProfile/articlesProfileTable/articlesProfileTable.ts
 **/